import HomeHeader from "../HomePage/components/HomeHeader";
// import "../Homepage/home.css";
import CallIcon from "@mui/icons-material/Call";
import "./styles.css";
import MobileInput from "../../Components/MobileInput/MobileInput";
import { ChangeEvent, useEffect, useState } from "react";
import { useQuery } from "../../hooks/useQuery";
import { getCampaignDetails, submitCampaignForm } from "../../api/campaign";
import { CampaignItem } from "../../models/campaign";
import { CircularProgress, Dialog } from "@mui/material";
import { useSnackbar } from "../../context/SnackbarContext";

const CampaignPage = () => {
  const searchParams = useQuery();

  const uuid = searchParams.get("cid");

  const [activeCampaign, setActiveCampaign] = useState<CampaignItem | null>(
    null
  );

  const getCampaign = async () => {
    setLoading(true);
    const resp = await getCampaignDetails(uuid || "");
    if (resp) {
      setActiveCampaign(resp.data);
    } else {
      setActiveCampaign(null);
    }
    setLoading(false);
  };

  useEffect(() => {
    if (uuid) {
      getCampaign();
    }
  }, [uuid]);

  const handleGuide = () => {
    window.open(
      "https://tascoutsourcing.com/campaigns/emiratization-guidebook/",
      "_blank"
    );
  };

  const [form, setForm] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phoneNumber: "",
    companyName: "",
  });

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    setForm((prevState) => ({
      ...prevState,
      [e.target.name]: e.target.value,
    }));
  };

  const handlePhoneChange = (value: string) => {
    setForm((prevState) => ({
      ...prevState,
      ["phoneNumber"]: value,
    }));
  };

  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);

  const { showSnackbar } = useSnackbar();

  const handleSubmit = async () => {
    setLoading(true);

    if (
      !!form.firstName.length &&
      !!form.lastName.length &&
      !!form.email.length &&
      !!form.companyName.length &&
      !!form.phoneNumber.length
    ) {
      const resp = await submitCampaignForm({
        campaignUUID: uuid,
        formData: [
          { key: "firstName", value: form.firstName },
          { key: "lastName", value: form.lastName },
          { key: "email", value: form.email },
          { key: "phoneNumber", value: form.phoneNumber },
          { key: "companyName", value: form.companyName },
        ],
      });
      if (resp) {
        setSubmitted(true);
      }
    } else {
      showSnackbar("Please enter all the details", "error");
    }

    setLoading(false);
  };

  return (
    <div className="main_home_container">
      <HomeHeader />
      <div className="home_section_1">
        {submitted ? (
          <div className="max_home_width">
            <div className="home_section_1_wrapper">
              <div className="home_section_1_content">
                <div>
                  <h1 className="main_content_text max_text_width fs-48">
                    <span className="ft_text">Success!</span>
                    <span className="text-white">
                      {" "}
                      Your form has been submitted
                    </span>
                  </h1>
                  <h3 className="main_content_text max_text_width text-white">
                    You will receive an email from us shortly.
                  </h3>
                </div>
                <div className="display_center">
                  <div onClick={handleGuide} className="callButton">
                    <CallIcon />
                    {/* <img src={arrowImg} alt="logo" className="home_arrow_btn" /> */}
                    <div>Contact Us</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <div className="max_home_width">
            {activeCampaign ? (
              <div className="home_section_1_wrapper">
                <div className="home_section_1_content">
                  <h1 className="main_content_text_left max_text_width fs-48">
                    <span className="ft_text">
                      Claim Your 3-Month Free Pass!
                    </span>
                    <span className="text-white">
                      {" "}
                      Access premium features now.
                    </span>
                  </h1>
                  <h1 className="main_content_text_left max_text_width text-white fs-18">
                    Prefer a call to explain in detail?
                  </h1>
                  <div onClick={handleGuide} className="callButton">
                    {/* <img src={arrowImg} alt="logo" className="home_arrow_btn" /> */}
                    <div>Download Guide</div>
                  </div>
                </div>
                <div className="home_form_container">
                  <div className="main_content_text_left max_text_width">
                    <span className="ft_text_2 fs-32">
                      Fill in your details
                    </span>
                  </div>
                  <div className="home_form_line_wrapper">
                    <div className="ak_form_input_wrapper">
                      <input
                        className="ak_form_input"
                        type="text"
                        placeholder="First Name*"
                        onChange={handleChange}
                        name="firstName"
                        value={form.firstName}
                      />
                    </div>
                    <div className="ak_form_input_wrapper">
                      <input
                        className="ak_form_input"
                        type="text"
                        placeholder="Last Name*"
                        onChange={handleChange}
                        name="lastName"
                        value={form.lastName}
                      />
                    </div>
                  </div>
                  <div className="home_form_line_wrapper">
                    <MobileInput handleChange={handlePhoneChange} />
                  </div>
                  <div className="home_form_line_wrapper">
                    <div className="ak_form_input_wrapper">
                      <input
                        className="ak_form_input"
                        type="email"
                        placeholder="Work Email*"
                        onChange={handleChange}
                        name="email"
                        value={form.email}
                      />
                    </div>
                    <div className="ak_form_input_wrapper">
                      <input
                        className="ak_form_input"
                        type="text"
                        placeholder="Company Name*"
                        onChange={handleChange}
                        name="companyName"
                        value={form.companyName}
                      />
                    </div>
                  </div>

                  <div
                    onClick={handleSubmit}
                    className="callButton form_submit_btn"
                  >
                    <div>Claim Access</div>
                  </div>
                </div>
              </div>
            ) : (
              <div className="home_section_1_wrapper">
                <div className="home_section_1_content">
                  <div>
                    <h1 className="main_content_text max_text_width fs-48">
                      <span className="ft_text">Oops! It's Over.</span>
                      <span className="text-white">
                        {" "}
                        Looks like you missed it!
                      </span>
                    </h1>
                    <h3 className="main_content_text max_text_width text-white">
                      The campaign has already concluded or has been
                      discontinued. Keep an eye out for what's next!
                    </h3>
                  </div>
                  <div className="display_center">
                    <div onClick={handleGuide} className="callButton">
                      {/* <img src={arrowImg} alt="logo" className="home_arrow_btn" /> */}
                      <div>Download Guide</div>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        )}
      </div>
      <Dialog open={loading}>
        <div className="submit_loader">
          <CircularProgress color="inherit" size={30} />
        </div>
      </Dialog>
    </div>
  );
};

export default CampaignPage;
